import type { Token } from "@ext/markdown/core/render/logic/Markdoc";

/** Everything of `Token` except `attrs`: markdown-it types it as pairs, this pipeline reads a record. */
export type DerivedTokenInit = Omit<Partial<Token>, "attrs"> & { attrs?: unknown };

/** A token standing in for `from`, keeping the line it was written on. No `map` on the source, no key. */
export const derivedToken = (from: Token, token: DerivedTokenInit): Token =>
	(from?.map ? { ...token, map: from.map } : token) as Token;

/** Gives a transformer's result the line of the token it replaced. A map it set itself is left alone. */
export const inheritMap = (from: Token, to: Token | Token[]): void => {
	if (!from?.map) return;
	for (const token of Array.isArray(to) ? to : [to]) {
		if (token && typeof token === "object" && !token.map) token.map = from.map;
	}
};
